import { API, graphqlOperation, Auth } from 'aws-amplify';

export default {
    namespaced:true,
    state: {
        user: null,
        authState: null
    },
    mutations: {
        user: (state, payload) => { state.user = payload.value },
        authState: (state, payload) => { state.authState = payload.value }
    },
    getters: {
        email: (state) => state.user ? state.user.attributes.email : null,
        isHelpdesk: (state) => state.user?.signInUserSession?.accessToken && Array.isArray(state.user.signInUserSession.accessToken.payload["cognito:groups"]) ? state.user.signInUserSession.accessToken.payload["cognito:groups"].includes('helpdesk') : false,
        isOwner: (state) => (payload) => {
            if(!state.user || !payload.item) {
                return false;
            }
            return state.user.username == payload.item.owner;
        }
    },
    actions: {
        generateSecret: {
            root: true,
            handler() {
                var m = Math.random();
                var n = Math.random();
                return `${btoa(m)}${btoa(m+n)}${btoa(n)}`;
            }
        },

        getAccessToken: async(context,payload) => {
            const c = await API.graphql(graphqlOperation(`query Get${payload.entity}($id: ID!, $editors: [String!]!) {
                get${payload.entity}(id: $id) {
                    accessRightsToken(editors: $editors)
                }}
                  `, { id: payload.id, editors: payload.editors }));
              
              return c.data[`get${payload.entity}`].accessRightsToken;
        },

        requestAccess: async(context,payload) => {
            const c = await API.graphql(graphqlOperation(`mutation GetAccess($token: String!) {
                requestAccess(token:$token)
            }`, { token: payload.token }));
              
            return c.data.requestAccess;
        },
        revokeAccess: async(context,payload) => {
            const c = await API.graphql(graphqlOperation(`mutation RevokeAccess($input: RevokeAccessInput!) {
                revokeAccess(input:$input)
            }`, { input: payload }));
              
            return c.data.revokeAccess;
        },
        signOut: async() => {
            try {
                await Auth.signOut();
            } catch (error) {
                console.error('error signing out: ', error);
            }
        },

        createACContact: async(context, payload) => {
            await API.graphql(graphqlOperation(`mutation CreateContact($input:ACCreateContactInput!) {
                ACCreateContact(input: $input)
              }`, { input: payload }));
        },

        changePassword: async (context, payload) => {
            let user = await Auth.currentAuthenticatedUser();
            console.debug('authenticated user', user);
            let result = await Auth.changePassword(user, payload.oldPassword, payload.newPassword);
            return result;
        }
    }
}